module.exports = __webpack_public_path__ + "media/images/site/estrada2-8da911ccd36f2647bbb63221a4115e03.jpg";